import { html } from 'onefold';
import { CodeBlock } from '../../components/CodeBlock';
import { Callout } from '../../components/Callout';

export function NetlifyPage(): Node {
  return html`
    <div>
      <h1>Deploy to Netlify</h1>
      <p>Netlify supports SPA fallback via a <code>_redirects</code> file. Use the default <strong>path-based routing</strong>.</p>

      <h2>Quick Deploy</h2>
      <ol>
        <li>Push your project to GitHub/GitLab/Bitbucket</li>
        <li>Go to <a href="https://app.netlify.com/start" target="_blank">app.netlify.com</a> and connect your repo</li>
        <li>Configure build settings:</li>
      </ol>

      <table>
        <tr><th>Setting</th><th>Value</th></tr>
        <tr><td>Build command</td><td><code>npm run build</code></td></tr>
        <tr><td>Publish directory</td><td><code>dist</code></td></tr>
      </table>

      <h2>SPA Fallback with _redirects</h2>
      <p>Create a <code>public/_redirects</code> file (or place in your <code>dist/</code> output) so Netlify serves <code>index.html</code> for all routes:</p>
      ${CodeBlock(`/*    /index.html   200`, 'text')}

      <p>If you use a <code>public/</code> folder that gets copied to dist, place <code>_redirects</code> there. Otherwise add it to your build script:</p>
      ${CodeBlock(`// build.mjs
import { writeFileSync } from 'node:fs';

// ... after esbuild ...

// SPA fallback for Netlify
writeFileSync('dist/_redirects', '/*    /index.html   200\\n');`)}

      ${Callout('Without the _redirects file, navigating directly to /about will return a 404 from Netlify.')}

      <h2>Alternative: netlify.toml</h2>
      <p>You can also configure redirects in <code>netlify.toml</code> at the project root:</p>
      ${CodeBlock(`[build]
  command = "npm run build"
  publish = "dist"

[[redirects]]
  from = "/*"
  to = "/index.html"
  status = 200`, 'toml')}

      <h2>Router Configuration</h2>
      <p>No special configuration needed — path mode works with the redirect rule:</p>
      ${CodeBlock(`import { Router, mount } from 'onefold';

const app = Router([
  { path: '/', view: () => Home() },
  { path: '/about', view: () => About() },
], () => NotFound());

mount(app, document.getElementById('app')!);`)}

      <h2>Deploy via CLI</h2>
      ${CodeBlock(`# Install Netlify CLI
npm i -g netlify-cli

# Link to site and deploy
netlify link
netlify deploy --dir=dist

# Deploy to production
netlify deploy --dir=dist --prod`, 'bash')}

      <h2>Next Steps</h2>
      <ul>
        <li><a href="/deployment/cloudflare">Cloudflare Pages</a> — edge deployment with Workers</li>
        <li><a href="/deployment/aws">AWS S3 + CloudFront</a> — self-managed hosting</li>
      </ul>
    </div>
  `;
}
